import moment from 'moment'
import { fetchRecurringCharges } from '../../actions'

export function deleteRecurringCharge(){
  return (dispatch, getState ) => {
    const { organization, editRecurringChargeForm } = getState()
    const { id } = editRecurringChargeForm 

    dispatch({type:'BEGIN_SUBMIT_DELETE_RECURRING_CHARGE'})
    $.ajax({
      url: `/organizations/${organization.name}/recurring_charges/${id}.json`,
      method: 'delete',
      success: (response) => {
        dispatch({type:'SUCCESS_SUBMIT_DELETE_RECURRING_CHARGE'})
        dispatch(fetchRecurringCharges())
      },
      error: xhr => {
        const errors = $.parseJSON(xhr.responseText).errors
        dispatch({type:'FAILED_SUBMIT_DELETE_RECURRING_CHARGE', payload: errors})
      },
    })
  }
}

export function updateRecurringCharge(){
  return (dispatch, getState) => {
    const { editRecurringChargeForm, organization, resident } = getState()
    const { name, amount, payment_source, id, starts_at, interval, interval_count, 
            ends_at, occurrences, ends_type, has_credit_card_to_charge, email, due_days_after_invoice } = editRecurringChargeForm

    function getPaymentSource(){
      if (payment_source && (payment_source.kind === 'card' || payment_source.kind === 'bank_account')) {
        return payment_source.id
      } else {
        return null
      }
    }

    function getPaymentMethod(){
      if (payment_source && (payment_source.kind === 'card' || payment_source.kind === 'bank_account')) {
        return 'online'
      } else if (payment_source && payment_source.kind == 'use_balance') {
        return 'balance'
      } else {
        return 'invoice'
      }
    }

    $.ajax({
      url: `/organizations/${organization.name}/recurring_charges/${id}.json`,
      method: 'patch',
      data: {
        recurring_charge: {
          id,
          name,
          amount,
          email,
          due_days_after_invoice,
          payment_source_id: getPaymentSource(),
          payment_method: getPaymentMethod(),
          interval_count,
          interval,
          starts_at: moment(starts_at).format("YYYY-MM-DD"),
          ends_type,
          ends_at: ends_at ? moment(ends_at).format("YYYY-MM-DD") : null,
          occurrences,
        },
      },
      success: (response) => {
        dispatch({type:'SUCCESS_SUBMIT_EDIT_RECURRING_CHARGE'})
        dispatch(fetchRecurringCharges())
      },
      error: xhr => {
        const errors = $.parseJSON(xhr.responseText).errors
        dispatch({type:'FAILED_SUBMIT_EDIT_RECURRING_CHARGE', payload: errors})
      },
    })
  }
}